/**
 * @generated SignedSource<<427e2cc0190a1800eb2ebc2dcfc20509>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AuthorizeAgentLicensingDataQuery$variables = Record<PropertyKey, never>;
export type AuthorizeAgentLicensingDataQuery$data = {
  readonly licensingData: {
    readonly agentsLeft: number | null | undefined;
  } | null | undefined;
};
export type AuthorizeAgentLicensingDataQuery = {
  response: AuthorizeAgentLicensingDataQuery$data;
  variables: AuthorizeAgentLicensingDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LicensingData",
    "kind": "LinkedField",
    "name": "licensingData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "agentsLeft",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthorizeAgentLicensingDataQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AuthorizeAgentLicensingDataQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "36ee7bd2e954fe996efeec3a456bdf86",
    "id": null,
    "metadata": {},
    "name": "AuthorizeAgentLicensingDataQuery",
    "operationKind": "query",
    "text": "query AuthorizeAgentLicensingDataQuery {\n  licensingData {\n    agentsLeft\n  }\n}\n"
  }
};
})();

(node as any).hash = "f1a32777aa26a178839e3c113f6557c6";

export default node;
